import React from "react";
import { Typography } from "antd";

export const NoActionDisplay = () => {
  return <Typography.Text type="secondary" style={{
    color: 'var(--white-text-color)',
  }}>No Action</Typography.Text>;
};